import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PdfService {
  constructor() {}

  async download(docDefinition: any, fileName = 'document.pdf'): Promise<void> {
    // Lazy load of pdfmake and fonts only when needed
    const pdfMakeModule = await import('pdfmake/build/pdfmake');
    const pdfFonts = await import('pdfmake/build/vfs_fonts');

    const pdfMake = pdfMakeModule.default || pdfMakeModule;
    pdfMake.vfs = (pdfFonts as any).vfs;

    // Creation and download of the PDF
    pdfMake.createPdf(docDefinition).download(fileName);
  }
}
